const URL = {
	INDEX: '',
	HOME: '/:partner',
	FACILITY_HOME: '/:partner/:facility',
	IFRAME_HOME: '/iframe/:partner',
	IFRAME_FACILITY_HOME: '/iframe/:partner/:facility',
	PROMOTION: '/:partner/permittype2',
	FACILITY_PROMOTION: '/:partner/:facility/permittype2',
	ABOUT: '/:partner/about',
	CANCELRESERVATION: '/:partner/cancel/:ticket_id',
	BOOKING_CANCEL_REDIRECT: 'cancel',
	IFRAME_CANCELRESERVATION: '/iframe/:partner/cancel/:ticket_id',
	SMSRESERVATION: '/:partner/sms/:ticket_id',
	IFRAME_SMSRESERVATION: '/:partner/sms/:ticket_id',
	CONTACT: '/:partner/contact',
	PAYMENT: '/:partner/payment',
	PAYMENT_SUCCESS: '/:partner/paymentsuccess',
	PAYMENT_FAIL: '/:partner/paymentfails',
	FACILITY_PAYMENT_SUCCESS: '/:partner/:facility/paymentsuccess',
	FACILITY_PAYMENT_FAIL: '/:partner/:facility/paymentfails',
	RECOVER_TICKET: '/:partner/recoverTicket',
	THANKYOU: '/:partner/download',
	FACILITY_THANKYOU: '/:partner/:facility/download',
	SIGNUP: '/:partner/signup',
	FORFOT_PASSWORD: '/:partner/reset-password/:token_id',
	SEND_EMAIL_FORGOT_PASSWORD: '/:partner/send-email',
	PASS: '/:partner/pass',
	PASSCREATE: '/:partner/pass-create',
	PERMITPURCHASE: '/:partner/permit-purchase',
	FACILITY_PERMITPURCHASE: '/:partner/:facility/permit-purchase',
	USER: '/:partner/user',
	USER_PROFILE: '/:partner/user-profile',
	PASS_PAYMENT_SUCCESS: '/:partner/userpass-after-payment',
	PASS_PAYMENT_FAIL: '/:partner/userpass-payment-failed',
	NAVIGATING: '/navigating/:acc/:ref',
	NAVIGATING_RECEIPT: '/navigating/:acc/:ref/:isreceipt',
	// NAVIGATING_PARTNER: '/navigating/:acc/:ref/:isreceipt/:secret',
	NAVIGATING_PARTNER: '/navigating/:acc/:ref/:isreceipt/:partner',
	USER_NAVIGATING_PERMIT: '/navigating/:acc/:ref/:isreceipt/:token/:partner',
	NAVIGATING_MASQUERADE_PARTNER: '/navigating/:acc/:ref/:isreceipt/:masquerade/:partner',
	USER_NAVIGATING_MASQUERADE_PERMIT: '/navigating/:acc/:ref/:isreceipt/:token/:masquerade/:partner',
	GUEST_NAVIGATING: '/navigating/:token/:partner',
	BOOKTICKET: '/:partner/booking',
	CHECKOUT_PASSES: '/:partner/booking/checkout-passes',
	AAA_PAYMENT_RESPONSE: '/:partner/booking/paymentResponse',
	AAA_PAYMENT_FAILED: '/:partner/booking/paymentFailed',
	AAA_PAYMENT_SUCCESS: '/:partner/booking/payment-success',
	AAA_FAILED_COMPONENT: '/:partner/booking/payment-failure',
	AAA_BOOKING_RESPONSE: '/:partner/booking/booking-response',
	TICKET: '/:partner/ticket/:ticketId',
	TICKET_VIEW: '/:partner/ticket',
	// RESPONSIVE_RESERVATION_FACILITY: '/book-reservation',
	RESPONSIVE_RESERVATION: '/:partner/book-reservation',
	RESPONSIVE_RESERVATION_FACILITY: '/:partner/book-reservation/:resfacility',
	IFRAME_RESPONSIVE_RESERVATION: '/iframe/:partner/book-reservation',
	IFRAME_RESPONSIVE_RESERVATION_FACILITY: '/iframe/:partner/book-reservation/:resfacility',
	RESPONSIVE_PERMIT_REQUEST: '/:partner/permit-request',
	PAYMENT_PERMIT_REQUEST: '/:partner/payment-permit-request/:permit_id',
	LOGIN: '/:partner/login',

	BASE_HOME: '',
	BASE_ABOUT: '/about',
	BASE_CONTACT: '/contact',
	BASE_PAYMENT: '/payment',
	BASE_PAYMENT_SUCCESS: '/paymentsuccess',
	BASE_PAYMENT_FAIL: '/paymentfails',
	BASE_RECOVER_TICKET: '/recoverTicket',
	BASE_THANKYOU: '/download',
	BASE_SIGNUP: '/signup',
	BASE_FORFOT_PASSWORD: '/reset-password/:token_id',
	BASE_SEND_EMAIL_FORGOT_PASSWORD: '/send-email',
	BASE_PASS: '/pass',
	BASE_PASSCREATE: '/pass-create',
	BASE_USER: '/user',
	BASE_USER_PROFILE: '/user-profile',
	BASE_PASS_PAYMENT_SUCCESS: '/userpass-after-payment',
	BASE_PASS_PAYMENT_FAIL: '/userpass-payment-failed',
	BASE_NAVIGATING: '/navigating/:acc/:ref',
	BASE_NAVIGATING_RECEIPT: '/navigating/:acc/:ref/:isreceipt',
	BASE_NAVIGATING_PARTNER: '/navigating/:acc/:ref/:isreceipt/:secret',
	BASE_BOOKTICKET: '/booking',
	BASE_CHECKOUT_PASSES: '/booking/checkout-passes',
	BASE_AAA_PAYMENT_RESPONSE: '/booking/paymentResponse',
	BASE_AAA_PAYMENT_FAILED: '/booking/paymentFailed',
	BASE_AAA_PAYMENT_SUCCESS: '/booking/payment-success',
	BASE_AAA_FAILED_COMPONENT: '/booking/payment-failure',
	BASE_AAA_BOOKING_RESPONSE: '/booking/booking-response',
	BASE_TICKET: '/ticket/:ticketId',
	BASE_TICKET_VIEW: '/ticket',
	//BASE_RESPONSIVE_RESERVATION: '/book-reservation',
	BASE_RESPONSIVE_RESERVATION: '/:partner/reservation/',

	// for the booking Edit 
	BOOKING_EDIT: '/:partner/reservation/:id',
	BOOKING_EDIT_REDIRECT: 'reservation',
	IFRAME_BOOKING_EDIT: '/iframe/:partner/reservation/:id',
	// Booking Edit End 

	EXTERNAL: 'https://www.npmjs.com/package/qrcode.react',
	PARKENGAGE_LOGO_URL: 'https://parkengage.com/static/media/logo.8ed76367.svg',
	RESERVATION: 'https://demo-reservation.parkengage.com/',
	WARNING_OR_CITATION: ':partner/:warnorcit/:encfacility/:id',
	WARNING_OR_CITATION_URL: '/:partner/:route/:facility/:id',
	HOME2: '/:partner/:route/:facility',
	GET_FACILITY_RATE: 'pave-web-get-facility-rate',
	CONFIRMATION_SCREEN: '/:partner/paymentResponse',
	TICKET_EXTEND: '/:partner/extend/:ticket_id',
	EXTEND_SUCCESS: '/:partner/extend-success',
	SCAN_TOKEN_VALIDATE: '/:partner/validate',
	TESTURL: '/:partner/validPermit',

	// EOS-740
	FIND_RESERVATION: '/:partner/find-reservation/:action',
	IFRAME_FIND_RESERVATION: '/iframe/:partner/find-reservation/:action',
	// EOS-740

	// EOS-973
	FISERV_IFRAME_FORMAT_URL: 'cardnumbernumericonly=true&useexpiryfield=true&useexpiry=true&usecvv=true&enhancedresponse=true&formatinput=true&maskfirsttwo=true&placeholder=Enter%20Card%20Number&cardlabel=Card%20Number%20*&cardinputmaxlength=19&expirylabel=Expiry%20Date%20*&cvvlabel=CVV%20*&placeholdermonth=MM&placeholderyear=YYYY&invalidinputevent=true&invalidcvvevent=true&invalidexpiryevent=true&onFormValid=true&placeholdercvv=511',

}

export default URL
